import {
    Alignment as DMSAlignment,
    ButtonPlacement as DMSButtonPlacement,
    CacheModes as DMSCacheModes,
    ColumnFilterTypes as DMSColumnFilterTypes,
    CssClass as DMSCssClass,
    DisplayModes as DMSDisplayModes,
    EditModes as DMSEditModes,
    EncodingTypes as DMSEncodingTypes,
    FormModes as DMSFormModes,
    MappingDisplayType as DMSMappingDisplayType,
    MappingTypes as DMSMappingTypes,
    NotificationTypes as DMSNotificationTypes,
    TemplateTypes as DMSTemplateTypes,
    TreeLinkTypes as DMSTreeLinkTypes,
} from "./index";

import { ColumnTypes as DMSColumnTypes, GridControlTypes as DMSGridControlTypes, GridTypes as DMSGridTypes } from "Service/Client";

/**
 * ## Enums
 * List of all available enums.
 *
 * Please use the links below to navigate to the documentation of each enum.
 */
export namespace Enums {
    /**
     * Click {@link Alignment|here} for the documentation of Alignment.
     */
    export const Alignment = DMSAlignment;
    /**
     * Click {@link ButtonPlacement|here} for the documentation of ButtonPlacement.
     */
    export const ButtonPlacement = DMSButtonPlacement;
    /**
     * Click {@link CacheModes|here} for the documentation of CacheModes.
     */
    export const CacheModes = DMSCacheModes;
    /**
     * Click {@link ColumnFilterTypes|here} for the documentation of ColumnFilterTypes.
     */
    export const ColumnFilterTypes = DMSColumnFilterTypes;
    /**
     * Click {@link ColumnTypes|here} for the documentation of ColumnTypes.
     */
    export const ColumnTypes = DMSColumnTypes;
    /**
     * Click {@link CssClass|here} for the documentation of CssClass.
     */
    export const CssClass = DMSCssClass;
    /**
     * Click {@link DisplayModes|here} for the documentation of DisplayModes.
     */
    export const DisplayModes = DMSDisplayModes;
    /**
     * Click {@link EditModes|here} for the documentation of EditModes.
     */
    export const EditModes = DMSEditModes;
    /**
     * Click {@link EncodingTypes|here} for the documentation of EncodingTypes.
     */
    export const EncodingTypes = DMSEncodingTypes;
    /**
     * Click {@link FormModes|here} for the documentation of FormModes.
     */
    export const FormModes = DMSFormModes;
    /**
     * Click {@link GridControlTypes|here} for the documentation of GridTypes.
     */
    export const GridControlTypes = DMSGridControlTypes;
    /**
     * Click {@link GridTypes|here} for the documentation of GridTypes.
     */
    export const GridTypes = DMSGridTypes;
    /**
     * Click {@link MappingDisplayType|here} for the documentation of MappingDisplayType.
     */
    export const MappingDisplayType = DMSMappingDisplayType;
    /**
     * Click {@link MappingTypes|here} for the documentation of MappingTypes.
     */
    export const MappingTypes = DMSMappingTypes;
    /**
     * Click {@link NotificationTypes|here} for the documentation of NotificationTypes.
     */
    export const NotificationTypes = DMSNotificationTypes;
    /**
     * Click {@link TemplateTypes|here} for the documentation of TemplateTypes.
     */
    export const TemplateTypes = DMSTemplateTypes;
    /**
     * Click {@link TreeLinkTypes|here} for the documentation of TreeLinkTypes.
     */
    export const TreeLinkTypes = DMSTreeLinkTypes;
}
